import { AutoStoriesOutlined } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

import { useApiData } from '../../hooks/useApiData';
import HandbookSignModal from './HandbookSignModal';

const HandbookAssignmentPrompt: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const [signDialogOpen, setSignDialogOpen] = useState(false);

  const { data: handbooks, refresh } = useApiData((api) =>
    api.profiles.getMyHandbooks()
  );

  const needsActionHBs =
    handbooks?.filter((hb) => ['pending', 'overdue'].includes(hb.status)) ?? [];
  const hasOverdue = needsActionHBs.some((ha) => ha.status === 'overdue');

  if (needsActionHBs.length === 0) {
    return null;
  }

  return (
    <>
      <Dialog open={dialogOpen} maxWidth="xs">
        <DialogTitle sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1,
            }}
          >
            <Typography variant="h4">
              {hasOverdue
                ? 'You have overdue handbook assignments!'
                : 'You have assigned handbooks!'}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {hasOverdue && (
            <Typography align="center" sx={{ fontWeight: 'bold', my: 1 }}>
              IMMEDIATE ACTION REQUIRED
            </Typography>
          )}
          <Typography>
            Please review the handbooks and sign the acknowledgement statement
            to complete the process.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setDialogOpen(false)}>
            Close
          </Button>

          <Button
            startIcon={<AutoStoriesOutlined />}
            variant="contained"
            onClick={() => {
              setDialogOpen(false);
              setSignDialogOpen(true);
            }}
          >
            Complete now
          </Button>
        </DialogActions>
      </Dialog>
      {signDialogOpen &&
        needsActionHBs.map((hb, idx) => (
          <HandbookSignModal
            key={`${hb.handbook_id}-${idx}`}
            refresh={refresh}
            handbook={hb}
          />
        ))}
    </>
  );
};

export default HandbookAssignmentPrompt;
